import React from "react";
import { CSSTransition } from "react-transition-group";
import ClickAway from "./../Functional/ClickAway";
import slidingMenuStyles from "./SlidingMenu.module.scss"
import animationStyles from "./animationStyles.module.scss";
import classNames from "classnames";

const slideInClassNames = {
    enter: animationStyles['enter'],
    enterActive: animationStyles['enter-active'],
    exit: animationStyles['exit'],
    exitActive: animationStyles['exit-active']
};

export default ({ children, isActive, closeTrigger, className, top, maskClassName }) => {
    const nodeRef = React.useRef(null);
    return <>
        <CSSTransition nodeRef={nodeRef} classNames={slideInClassNames} in={isActive} unmountOnExit timeout={400}>
            <div ref={nodeRef} className={classNames(slidingMenuStyles["sliding-menu"], className)} style={{top}}>
                <>
                    { isActive && <ClickAway ignoreParentClick={true} listener = {(e) => {
                        closeTrigger(e);
                    }}/> }
                    {children}
                </>
            </div>
        </CSSTransition>
        {isActive && <div className={classNames(slidingMenuStyles['sliding-menu-mask'], maskClassName)} style={{top}}/>}
    </>
        ;
};

